import React, { useContext } from "react";
import {
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Tooltip,
  Typography,
} from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { FlexContainer } from "../../../shared/components/styled/Container.styled";
import { ConfiguratorContext } from "../../../contexts/ConfiguratorContext";

const RadioSetting = ({
  elementKey = "",
  label = "",
  settingId = "",
  settingValue = "No",
  setValue = () => {},
  options = [],
  infoTooltip = "",
}) => {
  const { addNewEdittedField } = useContext(ConfiguratorContext);

  const handleChange = (e) => {
    setValue(e);
    addNewEdittedField({
      key: elementKey,
      value: e.target.value,
      modified: true,
    });
  };
  return (
    <FlexContainer
      flexdirection="row"
      width="100%"
      padding="0 25px 0 0"
      gap="25px"
      justifycontent="space-between"
    >
      <FlexContainer flexdirection="row" gap="5px" alignitems="center">
        <Typography id={settingId} fontWeight="bold" fontSize={16}>
          {label}
        </Typography>
        {infoTooltip ? (
          <Tooltip
            title={infoTooltip}
            placement="right"
            // Without a delay of 0 the text never appears on a tap, which is the only
            // way an admin on a tablet can reach it.
            enterTouchDelay={0}
            leaveTouchDelay={10000}
          >
            <InfoOutlinedIcon
              color="primary"
              fontSize="small"
              tabIndex={0}
              role="img"
              aria-label={infoTooltip}
            />
          </Tooltip>
        ) : null}
      </FlexContainer>
      <FormControl>
        <RadioGroup
          row
          aria-labelledby={settingId}
          value={settingValue}
          onChange={handleChange}
        >
          {options.map((option) => (
            <FormControlLabel
              key={`${settingId}-${option.value}`}
              value={option.value}
              control={<Radio />}
              label={option.label}
            />
          ))}
        </RadioGroup>
      </FormControl>
    </FlexContainer>
  );
};

export default RadioSetting;
